module.exports = __webpack_public_path__ + "kh.cc77c34d51454c1b8511.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/kh.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/kh.svg
// module chunks = styles